const base64UrlDecode = (str) => {
  const base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "===".slice((base64.length + 3) % 4);
  return window.atob(padded);
};

const isValidToken = (token) => {
  if (!token) return false;

  const parts = token.split(".");
  const isJwt = parts.length === 3;

  if (!isJwt) return true;

  try {
    const payloadPart = parts[1];
    const decoded = JSON.parse(base64UrlDecode(payloadPart));

    // If no exp, assume valid (avoid logging out users with non-expiring tokens)
    if (typeof decoded.exp !== "number") return true;

    const expiryTime = decoded.exp * 1000;
    return Date.now() < expiryTime;
  } catch {
    // On bad/invalid JWT payload, treat as invalid
    return false;
  }
};

export { isValidToken };
